import { Menu, MenuItem, Divider, Link } from '@mui/material';

import { IOptionsMenu } from '../../../interfaces/options.interface';

const styles = {
  menuContainer: {
    '& .MuiPaper-root': {
      borderRadius: '0.5rem',
      marginTop: '0.5rem',
      width: { sm: '15rem', xs: '100%' },
      color: '#374251',
      boxShadow:
        'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
      '& .MuiMenu-list': {
        padding: '0.5rem 0',
      },
      '& .MuiMenuItem-root': {
        '& .MuiSvgIcon-root': {
          fontSize: '1.25rem',
          color: '#374251',
          marginRight: 1.5,
        },
        '&:active': {
          backgroundColor: '#00000030',
        },
      },
    },
  },
};

const OptionsMenu = ({ open, handleClose, anchorEl, optionItems }: IOptionsMenu) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      elevation={0}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      sx={styles.menuContainer}
    >
      {optionItems
        ?.filter((item) => item.type === 'action')
        .map((item) => (
          <MenuItem key={item.label} onClick={item.clickHandler} disableRipple>
            {item.icon}
            {item.label}
          </MenuItem>
        ))}

      {optionItems?.some((item) => item.type === 'action') &&
        optionItems
          ?.filter((item) => item.type === 'download')
          .map((item, i) => {
            if (i === 0) {
              return <Divider variant='middle' key={item.label} />;
            }
          })}

      {optionItems
        ?.filter((item) => item.type === 'download')
        .map((item) => (
          <MenuItem
            component={Link}
            key={item.label}
            href={item.link ? item.link : ''}
            target='_blank'
            disableRipple
          >
            {item.icon}
            {item.label}
          </MenuItem>
        ))}
    </Menu>
  );
};

export default OptionsMenu;
